export default {
  general: {
    label: 'General',
    number: 0
  },
  editor: {
    label: 'Editor',
    number: 1
  },
  copyPaste: {
    label: 'Copy paste move',
    number: 2
  },
  leftPanels: {
    label: 'Left Panels',
    number: 3
  },
  rightPanel: {
    label: 'Right-hand panel',
    number: 4
  },
  undoRedo: {
    label: 'Undo and Redo',
    number: 5
  },
  view: {
    label: 'View',
    number: 6
  },
  textEditor: {
    label: 'Text Editor',
    number: 7
  },
  layersSelection: {
    label: 'Layers and Selection',
    number: 8
  },
  viewModes: {
    label: 'View Modes',
    number: 9
  }
};
